import { UnBinaryNodeWidget } from './UnBinaryNodeWidget';
import { UnBinaryNodeModel } from './UnBinaryNodeModel';
import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
export class UnBinaryNodeFactory extends AbstractReactFactory {
  constructor() {
    super('unbinary');
  }

  generateReactWidget(event) {
    let reduxProps = event.model.getReduxProps();
    return /*#__PURE__*/React.createElement(UnBinaryNodeWidget, {
      removeDomainNode: reduxProps["removeDomainNode"],
      renameDomainNode: reduxProps["renameDomainNode"],
      engine: this.engine,
      size: 50,
      model: event.model
    });
  }

  generateModel(event) {
    return new UnBinaryNodeModel();
  }

}